"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTextField = void 0;
var palette_1 = require("../../../theme/global/palette");
exports.MuiTextField = {
    root: {
        '&:hover .MuiInputLabel-root:not(.Mui-disabled)': {
            color: palette_1.palette.common.black,
        },
        '& .MuiInputBase-inputAdornedEnd': {
            '&[id="date-picker-inline-small"] + div': {
                '& svg': {
                    width: '1rem',
                    height: '1rem',
                },
            },
            '&[class*="MuiInputBase-input"] + div': {
                '& svg': {
                    width: '1.2rem',
                    height: '1.2rem',
                },
            },
        },
    },
};
